import React, { createContext, useContext } from 'react';

export const UserContext = createContext(null);

// Custom hook to use the user context
export const useUser = () => {
  return useContext(UserContext);
};